import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  

  constructor(
    public toastController: ToastController,
    private alertController: AlertController
  ) { }

  async presentAlertWithOptions(msm, callBack, button_confirm='Yes'){
    const alert = await this.alertController.create({
     
      header: '',
      message: msm,
      cssClass: 'my-alert-cancel',
      backdropDismiss:false,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (data) => {
          
          }
        }, {
          text: button_confirm,
          role: 'other',
          handler: () => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack());
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="primary" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">CONFIRM</ion-label>
     </ion-item>
    `
    await alert.present();
  }

  async presentAlertReturnOption(msm, callBack, button_confirm='Yes'){
    const alert = await this.alertController.create({
     
      header: '',
      message: msm,
      cssClass: 'my-alert-cancel',
      backdropDismiss:false,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (data) => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(false));
            }
          }
        }, {
          text: button_confirm,
          role: 'other',
          handler: () => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(true));
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="primary" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">CONFIRM</ion-label>
     </ion-item>
    `
    await alert.present();
  }

  async presentToastErrorWithOption(msm, callBack){
    const alert = await this.alertController.create({
     
      header: '',
      message: msm,
      cssClass: 'my-alert-cancel',
      backdropDismiss:false,
      buttons: [
       {
          text: 'OK',
          role: 'other',
          handler: () => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack());
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="danger" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">Error</ion-label>
     </ion-item>
    `
    await alert.present();
  }

  async presentToastError(msm, callBack){
    const alert = await this.alertController.create({
     
      header: '',
      message: msm,
      cssClass: 'my-alert-cancel',
      backdropDismiss:false,
      buttons: [
       {
          text: 'OK',
          role: 'other',
          handler: () => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack());
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="danger" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">Error</ion-label>
     </ion-item>
    `
    await alert.present();
  }
  async presentToastWarning(msm, callBack){
    const alert = await this.alertController.create({
     
      header: '',
      message: msm,
      cssClass: 'my-alert-cancel',
      backdropDismiss:false,
      buttons: [
       {
          text: 'OK',
          role: 'other',
          handler: () => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack());
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="warning" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">Error</ion-label>
     </ion-item>
    `
    await alert.present();
  }


  async presentToast(msm,callBack){
    const alert = await this.alertController.create({
     
      header: '',
      message: msm,
      cssClass: 'my-alert-cancel',
      backdropDismiss:false
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="success" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">Notification</ion-label>
     </ion-item>
    `
    await alert.present();
    setTimeout(() => {
      if (callBack!=null){
        return this.alertController.dismiss().then(()=>callBack());
      }
      this.alertController.dismiss();
    }, 2000);
  }

  async presentAlertPrompt(msm, callBack, button_confirm='Send') {
    const alert = await this.alertController.create({
      cssClass: 'my-alert-cancel',
      header: msm,
      inputs: [
        {
          name: 'text_alert',
          type: 'password',
          placeholder: msm,
          cssClass: 'specialClass',
          attributes: {
            minlength: 3
          }
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: button_confirm,
          handler: (data) => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="primary" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">CONFIRM</ion-label>
     </ion-item>
    `

    await alert.present();
  }

  async presentAlertPromptNoPassword(msm, callBack, button_confirm='Send') {
    const alert = await this.alertController.create({
      cssClass: 'my-alert-cancel',
      header: msm,
      inputs: [
        {
          name: 'text_alert',
          type: 'text',
          placeholder: msm,
          cssClass: 'specialClass',
          attributes: {
            minlength: 3
          }
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: button_confirm,
          handler: (data) => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="primary" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">CONFIRM</ion-label>
     </ion-item>
    `

    await alert.present();
  }

  async presentAlertPromptQuestion(msm, callBack, button_confirm='Send',span="") {
    const alert = await this.alertController.create({
      cssClass: 'my-alert-cancel',
      header: msm,
      inputs: [
        {
          name: 'text_alert',
          type: 'text',
          placeholder: msm,
          cssClass: 'specialClass',
          attributes: {
            minlength: 3
          }
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: button_confirm,
          handler: (data) => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        }
      ]
    });
    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="primary" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">CONFIRM</ion-label>
       <span>${span}<span>
     </ion-item>
    `

    await alert.present();
  }


  async presentAlertRadio(msm, callBack, button_confirm='Send') {
    
    const alert = await this.alertController.create({
      cssClass: 'my-alert-cancel',
      header: msm,
      inputs: [
        {
          name: 'radio1',
          type: 'radio',
          label: 'Chapter 7',
          value: 'Chapter 7',
          handler: (data) => {
            console.log('Radio 1 selected');
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          },
        },
        {
          name: 'radio2',
          type: 'radio',
          label: 'Chapter 11',
          value: 'Chapter 11',
          handler: (data) => {
            console.log('Radio 2 selected');
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        },
        {
          name: 'radio3',
          type: 'radio',
          label: 'Chapter 12',
          value: 'Chapter 12',
          handler: (data) => {
            console.log('Radio 3 selected');
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        },
        {
          name: 'radio4',
          type: 'radio',
          label: 'Chapter 13',
          value: 'Chapter 13',
          handler: (data) => {
            console.log('Radio 4 selected');
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: button_confirm,
          handler: (data) => {
            if (callBack!=null){
              this.alertController.dismiss().then(()=>callBack(data));
            }
          }
        }
      ]
    });

    const html_element_head = await document.getElementsByClassName('alert-head');
    html_element_head[0].innerHTML=`
    <ion-item lines='none' color="light">
       <ion-icon src="../../assets/icons/alert-circle.svg" color="primary" slot="start" size="large"></ion-icon>
       <ion-label  class="bold_alert">CONFIRM</ion-label>
     </ion-item>
    `

    await alert.present();
  }


 
}
